import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {Box, Typography} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import {LangContext} from "../../App";


const Footer = () => {
    const lang = useContext(LangContext)
    const content = {
        en: {
            home: "Home",
            about: "About Ayrarat",
            explore: "Explore",
            contact: "Contact",
            followUs: "Follow Us",
        },
        de: {
            home: "Startseite",
            about: "Über Ayrarat",
            explore: "Entdecken",
            contact: "Kontakt",
            followUs: "Folgen Sie uns",
        },
    }

    const { home, about, explore, contact, followUs } = content[lang] || content.en;
    return (
        <footer>
            <div className="container pb-4">
                <div className="row">
                    <div className="col-md-4">
                        <h4 style={{fontSize:'1rem'}}>{explore}</h4>
                        <ul className="footer-navigation">
                            <li><Link to={`/${lang}`}>{home}</Link></li>
                            <li><a href="/about">{about}</a></li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <h4 style={{fontSize:'1rem'}}>{contact}</h4>
                        <Typography sx={{
                            display:'flex',
                            alignItems:'center',
                            gap:'10px',
                            fontSize:'12px'
                        }}>
                            <LocationOnIcon />
                            5 Office, 4th Floor, 45 Orbeli Brothers, Yerevan, 0028, Armenia
                        </Typography>
                        <Typography sx={{
                            display:'flex',
                            alignItems:'center',
                            gap:'10px',
                            fontSize:'12px'
                        }}>
                            <CallIcon />
                            <a href="tel:+37495110700" style={{color:'#fff'}}>+374 95 110700</a>
                        </Typography>
                        <Typography sx={{
                            display:'flex',
                            alignItems:'center',
                            gap:'10px',
                            fontSize:'12px'
                        }}>
                            <EmailIcon />
                            <a href="mailto:ayrarattour@gmail.com" style={{color:'#fff'}}>ayrarattour@gmail.com</a>
                        </Typography>
                    </div>
                    <div className="col-md-4 text-end">
                        <h4 style={{fontSize:'1rem'}}>{followUs}</h4>
                        <ul className="social-media">
                            <li className='me-0'>
                                <a href="https://www.linkedin.com/company/ayrarattour/">
                                    <FontAwesomeIcon icon={faLinkedin} className='icon'/>
                                </a>
                            </li>
                            <li className='me-0'>
                                <a href="https://www.instagram.com/ayrarat.tours?igsh=MTNlaHlqZTE4dWZqbQ%3D%3D">
                                    <FontAwesomeIcon icon={faInstagram} className='icon'/>
                                </a>
                            </li>
                            <li className='me-0'>
                                <a href="https://www.tripadvisor.com/Attraction_Review-g293932-d11725821-Reviews-Ayrarat_Tour-Yerevan.html">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         className="icon icon-tabler icon-tabler-brand-tripadvisor" width="24"
                                         height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                                         fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                        <circle cx="6.5" cy="13.5" r="1.5"/>
                                        <circle cx="17.5" cy="13.5" r="1.5"/>
                                        <path d="M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"/>
                                        <path d="M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"/>
                                        <path d="M10.5 15.5l1.5 2l1.5 -2"/>
                                        <path d="M9 6.75c2 -.667 4 -.667 6 0"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                        <Box className="payment-icons payment-icons" sx={{
                            display:'flex',
                            marginTop:'20px',
                            gap:'10px',
                            justifyContent:'flex-end',
                            '& img':{
                                borderRadius:'5px',
                                height:'30px',
                            }
                        }}>
                            <img src="https://www.freeiconspng.com/uploads/visa-icon-0.png" alt="Visa" />
                            <img src="https://www.investopedia.com/thmb/F8CKM3YkF1fmnRCU2g4knuK0eDY=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/MClogo-c823e495c5cf455c89ddfb0e17fc7978.jpg" alt="MasterCard" />
                            <img src="https://img.icons8.com/color/1200/amex.jpg" alt="MasterCard" />
                        </Box>
                    </div>
                </div>
                <p style={{textAlign:'center',color:'#fff', fill:'#fff', position:'relative', top:'15px', fontSize:'12px'}}>
                    &copy;️ 2026 Ayrarat. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;